import { Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { NavComponent } from '../nav/nav.component';
import { RouterOutlet } from '@angular/router';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  standalone: true,
  imports: [NavComponent, RouterOutlet],
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  title = 'DKM focus 2020 CUPS Management App';

  constructor(translate: TranslateService) {

    translate.addLangs(['de', 'en']);

    // this language will be used as a fallback when a translation isn't found in the current language
    translate.setDefaultLang('de');

    // the lang to use, if the lang isn't available, it will use the current Browser Language
    translate.use(translate.getBrowserLang());
  }

}
